import { AppShell } from '@/shared/components/AppShell'
import { useLocation } from 'react-router-dom'

import { AppErrorBoundary } from './AppErrorBoundary'
import { AppProviders, type AppServices } from './AppProviders'

export function AppRoot({ services }: { services: AppServices }) {
  const { pathname } = useLocation()
  return (
    <AppErrorBoundary>
      <AppProviders services={services} pathname={pathname}>
        <AppShell header={services.demo ? <span className="demo-badge">模拟数据</span> : undefined} />
      </AppProviders>
    </AppErrorBoundary>
  )
}
